import faker from 'faker';
import { Factory } from 'miragejs';
import { SALESFORCE_TOWN, SALESFORCE_CALENDAR } from 'src/accounts/CreateAccount/constants';

const salesforceAccount = Factory.extend({
  id: () => faker.datatype.uuid(),
  cosmos_id: () => faker.datatype.uuid(),
  call_rescue_status: '',
  email: () => faker.internet.email(),
  calendar_name: () => faker.random.arrayElement(SALESFORCE_CALENDAR).value,
  has_calendar: () => true,
  name: () => `${faker.name.firstName()} ${faker.name.lastName()}`,
  notes: () => faker.random.words(),
  owner_id: () => faker.datatype.uuid(),
  phone: () => faker.phone.phoneNumber(),
  status: () => faker.random.word(),
  town: () => faker.random.arrayElement(SALESFORCE_TOWN).value,
  training_status: () => [
    {
      id: 'contact-id',
      name: 'contact-name',
      email: 'contact-email',
      phone: 'contact-phone',
    },
  ],
  company_industry: () => ({ id: faker.datatype.uuid(), name: faker.random.word() }),
});

export default salesforceAccount;
